"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormMeta = exports.useForm = exports.useField = void 0;
const react_1 = require("react");
const model_1 = require("../model");
const Form_1 = require("./Form");
const useField = (field, config) => {
    const setValue = (0, react_1.useState)(field.getValue())[1];
    const setMeta = (0, react_1.useState)(field.getMeta())[1];
    const setError = (0, react_1.useState)(field.getError())[1];
    const [sub] = (0, react_1.useState)({ current: null });
    if (!sub.current) {
        sub.current = field.asObservable().subscribe(setValue);
        sub.current.add(field.getMetaObservable().subscribe(setMeta));
        sub.current.add(field.getErrorObservable().subscribe(setError));
    }
    const resultRef = (0, react_1.useRef)({
        control: {
            get value() {
                return field.getValue();
            },
            onChange(nextValue) {
                field.update(nextValue);
            },
            onBlur() {
                var _a;
                if ((_a = config === null || config === void 0 ? void 0 : config.validateAfterTouch) !== null && _a !== void 0 ? _a : true) {
                    field.touch();
                }
            },
            get name() {
                return field.getName();
            }
        },
        get meta() {
            return field.getMeta();
        },
        get error() {
            return field.getError();
        }
    });
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            (_a = sub.current) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            sub.current = null;
        };
    }, []);
    return resultRef.current;
};
exports.useField = useField;
function useForm(initialValueOrModel, config) {
    var _a, _b;
    const isBuildFormValueRef = (0, react_1.useRef)(false);
    const formRef = (0, react_1.useRef)(null);
    if (((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.model) &&
        initialValueOrModel instanceof model_1.Model &&
        ((_b = formRef.current) === null || _b === void 0 ? void 0 : _b.model) !== initialValueOrModel) {
        console.error('useForm error: you must provide an equal instance of model on each render');
    }
    if (!formRef.current) {
        isBuildFormValueRef.current = !(initialValueOrModel instanceof model_1.Model);
        const model = initialValueOrModel instanceof model_1.Model
            ? initialValueOrModel
            : new model_1.Model(initialValueOrModel);
        formRef.current = new Form_1.Form(model, config);
    }
    (0, react_1.useEffect)(() => {
        return () => {
            var _a;
            if (isBuildFormValueRef.current) {
                (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.model.destroy();
            }
        };
    }, []);
    return formRef.current;
}
exports.useForm = useForm;
function useFormMeta(form) {
    const [value, setValue] = (0, react_1.useState)(form.getMetaValue());
    (0, react_1.useEffect)(() => {
        const sub = form.metaChanges().subscribe((next) => {
            setValue(next.value);
        });
        return () => {
            sub.unsubscribe();
        };
    }, []);
    return value;
}
exports.useFormMeta = useFormMeta;
//# sourceMappingURL=hooks.js.map